import styles from "../../../styles/pages/Management.module.scss";
import { Input, Button, Dropdownlist } from "@qastanfit/qastan-ui"
import { useEffect, useState, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../../hooks/redux";
import { getAllUsers, handleUpdateUser } from "../../../functions/fetch/user";
import { setNotification, setUsers } from "../../../redux/actions";
import * as crypto from 'crypto-js';

type Props = {
    user: User | null; 
    onEdit: () => void;
}

const EditUser: React.FunctionComponent<Props> = ({user, onEdit}) => {
    const dispatch = useAppDispatch();
    const userdata:UserData = useAppSelector(state => state.userdata);

    const [partnersList, setpartnersList] = useState<Array<string>>([]);
    const [selectedPartner, setselectedPartner] = useState("");
    
    const [rolesList, setrolesList] = useState<Array<string>>([]);
    const [selectedRole, setselectedRole] = useState("");

    const [isLoading, setisLoading] = useState(false);
    
    const updateUserObject = useRef<UpdateUserObject>({
        token: '',
        userid: '',
        username: '',
        firstname: '',
        lastname: '',
        language: '',
        role: '',
        relnr: ''
    });

    useEffect(()=>{
        if(user){
            updateUserObject.current = {
                token: userdata.token,
                userid: user.apiuserid.toString(),
                username: user.username,
                firstname: user.firstname,
                lastname: user.lastname,
                language: user.language,
                role: user.roleid.toString(),
                relnr: user.relnr.toString()
            }
        }
    }, [user])

    useEffect(()=>{
        if(partnersList.length > 0 && user?.relnr){
            const item = partnersList.find(v => v.split("_")[0] === user.relnr.toString())
            if(item){
                setselectedPartner(item);
            }
        }
    }, [partnersList, user])

    useEffect(()=>{
        if(rolesList.length > 0 && user?.roleid){
            const item = rolesList.find(v => v.split("_")[0] === user.roleid.toString())
            if(item){
                setselectedRole(item);
            }
        }
    }, [rolesList, user])

    const changeItem = (key:keyof UpdateUserObject, value:string) => {
        if(updateUserObject.current){
            updateUserObject.current[key] = value
        }
    }

    const saveUser = async () => {
        setisLoading(true)

        let u = await handleUpdateUser(updateUserObject.current)
        setisLoading(false)
        if(u.errorcode === 0){
            dispatch(setNotification({type:"success", title:"Succes", message:"Gebruiker succesvol gewijzigd"}))

            //Get new list of users
            let users = await getAllUsers(userdata);
            if(users.errorcode === 0){
                //Save data in localStorage as cache
                const stringified_users = JSON.stringify(users.object);
                const encrypted_users = crypto.AES.encrypt(stringified_users, process.env.REACT_APP_SECRET || "");
                localStorage.setItem("users", encrypted_users.toString());

                //Save data in Redux state
                dispatch(setUsers(users.object.users))
            }

            onEdit()
        }
        else {
            dispatch(setNotification({type:"error", title:"Error", message:`Gebruiker wijzigen mislukt. Reden: ${u.message}`}))
            console.error("Could not update user")
            console.log(u)
        }
    }

    return (
        <div className={styles.detail}>
            <div className={styles.header}>
                <h1 className={styles.title}>Gebruiker wijzigen</h1>
                <p className={styles.description}>Hier kan u de gebruiker zijn gegevens aanpassen.</p>
            </div>

            <div className={styles.body} style={{gap:"1.5rem"}}>
                <Input label="E-mailadres" type="text" value={user?.username} onChange={(target:HTMLInputElement)=>{changeItem("username", target.value)}}/>
                <Input label="Voornaam" type="text" value={user?.firstname} onChange={(target:HTMLInputElement)=>{changeItem("firstname", target.value)}}/>
                <Input label="Familienaam" type="text" value={user?.lastname} onChange={(target:HTMLInputElement)=>{changeItem("lastname", target.value)}}/>

                <div className={styles.input}>
                    <p className={styles.label}>Rol</p>
                    <Dropdownlist scrollTo options={rolesList} selected={selectedRole} onSelect={(v:any)=>{changeItem("role", v.value) ;setselectedRole(`${v.value}_${v.label}`)}} placeholder="Rol"/>
                </div>

                {!selectedRole.toLowerCase().includes("admin") && 
                <div className={styles.input}>
                    <p className={styles.label}>Partner</p>
                    <Dropdownlist scrollTo options={partnersList} selected={selectedPartner} onSelect={(v:any)=>{changeItem("relnr", v.value); setselectedPartner(`${v.value}_${v.label}`)}} placeholder={partnersList.length > 0 ? "Partner" : "Even geduld..."}/>
                </div>
                }

                <div className={styles.actions}>
                    <Button disabled={isLoading} isLoading={isLoading} onClick={()=>{saveUser()}}>Opslaan</Button>
                </div>
            </div>
        </div>
    )
}

export default EditUser;